'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/SpeakerHigh.js";
var p = Object.defineProperty, f = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var t = (r, e, o) => e in r ? p(r, e, { enumerable: true, configurable: true, writable: true, value: o }) : r[e] = o, m = (r, e) => {
  for (var o in e || (e = {}))
    c.call(e, o) && t(r, o, e[o]);
  if (a)
    for (var o of a(e))
      g.call(e, o) && t(r, o, e[o]);
  return r;
}, i = (r, e) => f(r, s(e));
const l = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, i(m({ ref: e }, r), { weights: t$1 })));
l.displayName = "SpeakerHigh";
export {
  l as SpeakerHigh
};
